export default __webpack_public_path__ + "static/media/0f9dbdfb410fcf14.894c1f91737355d1d94333cdc9e4fdf6.svg";